import React, { FC } from "react";

export const Post: FC<{}> = props => {
  return <p>Coming soon to a grapefruit near you</p>;
}
